import { PageTitle } from '@/components'
import { Button } from '@/components/ui'
import { Modal } from '@/components/ui/modal'

interface GenericMessageBoxProps {
  title: string
  message: string
  hasCancelButton: boolean
  cancelButtonTitle?: string
  submitButtonTitle?: string
  submitButtonAction?: () => void
  hasSubmitButton: boolean
  setShowMessageBox: (sM: boolean) => void
  showMessageBox: boolean
}

export const GenericMessageBox = (
  props: GenericMessageBoxProps,
): JSX.Element => {
  const {
    title,
    message,
    showMessageBox,
    setShowMessageBox,
    hasCancelButton = false,
    cancelButtonTitle,
    submitButtonTitle,
    submitButtonAction,
    hasSubmitButton = false,
  } = props

  const handleClose = () => {
    setShowMessageBox(false)
  }

  return (
    <Modal
      open={showMessageBox}
      onOpenChange={setShowMessageBox}
      size="sm"
      title={
        <div className="border-b border-monochrome-120 pb-4">
          <PageTitle title={title} />
        </div>
      }
      footer={
        <div className="flex w-full items-center gap-2 justify-end mt-4">
          {hasCancelButton && (
            <Button
              onClick={handleClose}
              className="w-full"
              variant="secondary"
              type="button"
            >
              {cancelButtonTitle}
            </Button>
          )}
          {hasSubmitButton && (
            <Button
              onClick={submitButtonAction}
              className="w-full"
              variant="primary"
              type="button"
            >
              {submitButtonTitle}
            </Button>
          )}
        </div>
      }
    >
      <div className="text-monochrome-1 text-body-medium">{message}</div>
    </Modal>
  )
}
